// Whether a phone number can receive a Swish payment: a Swedish mobile number. The server is the one
// that decides (SwishRecipient.TryCreate); this mirrors it only so the seller's field can refuse a
// number the server would refuse, before anything is sent.
//
// Swedish mobile series: 070, 072, 073, 076, 078 (from 1 Oct 2026, except 0783) and 079. Swish
// business numbers (123...), other countries and anything that is not a plain phone number are
// refused.
const MOBILE_SERIES = "023689";
const SEPARATORS = /[\s \-()]/g;

export function isSwedishMobile(input) {
  if (typeof input !== "string" || input.trim() === "") return false;
  const s = input.trim().replace(SEPARATORS, "");

  let digits;
  if (s.startsWith("+46")) digits = `0${s.slice(3)}`;
  else if (s.startsWith("0046")) digits = `0${s.slice(4)}`;
  else if (s.startsWith("46") && s.length === 11) digits = `0${s.slice(2)}`;
  else if (s.startsWith("+") || (s.startsWith("00") && s.length > 10)) return false;
  else digits = s;

  // "+46 (0)70..." keeps a trunk zero after the country code.
  if (digits.startsWith("00") && digits.length === 11) digits = digits.slice(1);

  if (!/^[0-9]+$/.test(digits)) return false;
  if (digits.startsWith("123") && digits.length === 10) return false;
  if (digits.length !== 10 || digits[0] !== "0" || digits[1] !== "7") return false;
  if (!MOBILE_SERIES.includes(digits[2])) return false;
  if (digits[2] === "8" && digits[3] === "3") return false;
  return true;
}
